// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lrKmoPWJ80yf870lVdpV {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 10000;
  pointer-events: auto;
}

.VaCrmNoo3wP6ANNaOduw {
  width: 100%;
  max-width: 500px;
  background-color: var(--vnsc-bg-secondary, #1e222d);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding-bottom: 24px;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease-out;
  will-change: transform;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-bottom: none;
}

.P1tmNR5X392lblb_rwTG {
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}

.Yl_jOH3xyreCIjLLwfy5 {
  width: 40px;
  height: 4px;
  background-color: var(--vnsc-text-muted, #64748b);
  border-radius: 2px;
}

.if_H16YTzzXEN_qoGMiC {
  padding: 0 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.hInGx_tfZWpCw6WI4iz4 {
  margin-bottom: 20px;
}

.Lne42pM0sor5IISUNFa4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #94a3b8);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.CLPpTna2q1n2pZ4lOT0r {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.BhMt1T4_I8nPDDCViRVf {
  min-height: 44px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;
}

.BhMt1T4_I8nPDDCViRVf:active,
.BhMt1T4_I8nPDDCViRVf.qnvGTyLEAi8FjAJSW4xg {
  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.I1TNpouK6Ym3IdnUIxku {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.B5skaWO8DqE_E79_mQSy {
  min-height: 72px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 4px;
  transition: background-color 0.2s, border-color 0.2s;
}

.PQNvSp9TZvwabXKGyqUc {
  font-size: 20px;
}

.Wr68Ht5swYCfA3BAJQyb {
  font-size: 11px;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.2;
  max-height: 2.4em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.B5skaWO8DqE_E79_mQSy:active,
.B5skaWO8DqE_E79_mQSy.qnvGTyLEAi8FjAJSW4xg {
  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.E5TwqJLspQmOYSauBWJI {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

._U1Pd2xueomDr0RBchPq {
  min-height: 40px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;
}

._U1Pd2xueomDr0RBchPq:active,
._U1Pd2xueomDr0RBchPq.qnvGTyLEAi8FjAJSW4xg {
  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.a_Bo3aN7JUucAKA8FK9h {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.kJKvpd0ye3h1_LUmIzWl {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.04));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.06));
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #94a3b8);
  font-size: 12px;
  cursor: pointer;
  user-select: none;
}

.kJKvpd0ye3h1_LUmIzWl input {
  margin: 0;
  cursor: pointer;
  accent-color: var(--vnsc-accent, #22d3ee);
}

.UYoV99reRzXLEqZbyEU7 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.Nx7hZy3OKTNu1k8fyEq3 {
  min-height: 44px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background-color 0.2s, border-color 0.2s;
}

.Nx7hZy3OKTNu1k8fyEq3:active,
.Nx7hZy3OKTNu1k8fyEq3.qnvGTyLEAi8FjAJSW4xg {
  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.EKbvtkhSKqiUvMYLUWyD {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.bOb5S75yAbRK5wmW9JO5 {
  min-height: 44px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;
  padding: 0 8px;
}

.bOb5S75yAbRK5wmW9JO5:active,
.bOb5S75yAbRK5wmW9JO5.qnvGTyLEAi8FjAJSW4xg {
  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.buBX960FHS0lusxsvHQJ {
  flex-shrink: 0;
}

.YOWWls9x9R015PZbick4 {
  font-weight: 600;
  margin-right: 6px;
}

.k8dNMISl3cdxGT3OHE4w {
  font-size: 11px;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/components/MobileToolbar.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mDAAmD;EACnD,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,0CAA0C;EAC1C,mCAAmC;EACnC,sBAAsB;EACtB,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;;EAEE,iEAAiE;EACjE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,iEAAiE;EACjE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;;EAEE,iEAAiE;EACjE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oDAAoD;AACtD;;AAEA;;EAEE,iEAAiE;EACjE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,cAAc;AAChB;;AAEA;;EAEE,iEAAiE;EACjE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n  pointer-events: auto;\r\n}\r\n\r\n.bottomSheet {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  background-color: var(--vnsc-bg-secondary, #1e222d);\r\n  border-top-left-radius: 16px;\r\n  border-top-right-radius: 16px;\r\n  padding-bottom: 24px;\r\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.3);\r\n  transition: transform 0.2s ease-out;\r\n  will-change: transform;\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-bottom: none;\r\n}\r\n\r\n.handleBarContainer {\r\n  width: 100%;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: grab;\r\n}\r\n\r\n.handleBar {\r\n  width: 40px;\r\n  height: 4px;\r\n  background-color: var(--vnsc-text-muted, #64748b);\r\n  border-radius: 2px;\r\n}\r\n\r\n.content {\r\n  padding: 0 16px;\r\n  max-height: 70vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.sectionTitle {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  margin-bottom: 12px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.timeframeGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.timeframeButton {\r\n  min-height: 44px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.timeframeButton:active,\r\n.timeframeButton.active {\r\n  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.toolsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.toolButton {\r\n  min-height: 72px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px 4px;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.toolIcon {\r\n  font-size: 20px;\r\n}\r\n\r\n.toolLabel {\r\n  font-size: 11px;\r\n  text-align: center;\r\n  white-space: normal;\r\n  word-wrap: break-word;\r\n  line-height: 1.2;\r\n  max-height: 2.4em;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n}\r\n\r\n.toolButton:active,\r\n.toolButton.active {\r\n  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.layoutGridCompact {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.gridItemCompact {\r\n  min-height: 40px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.gridItemCompact:active,\r\n.gridItemCompact.active {\r\n  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.syncOptionsCompact {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.syncOption {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.04));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.06));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.syncOption input {\r\n  margin: 0;\r\n  cursor: pointer;\r\n  accent-color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.featuresGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.featureButton {\r\n  min-height: 44px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.featureButton:active,\r\n.featureButton.active {\r\n  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.chartsGridCompact {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.chartItemCompact {\r\n  min-height: 44px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n  padding: 0 8px;\r\n}\r\n\r\n.chartItemCompact:active,\r\n.chartItemCompact.active {\r\n  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.chartIndicator {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chartSymbol {\r\n  font-weight: 600;\r\n  margin-right: 6px;\r\n}\r\n\r\n.chartTimeframe {\r\n  font-size: 11px;\r\n  opacity: 0.7;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `lrKmoPWJ80yf870lVdpV`,
	"bottomSheet": `VaCrmNoo3wP6ANNaOduw`,
	"handleBarContainer": `P1tmNR5X392lblb_rwTG`,
	"handleBar": `Yl_jOH3xyreCIjLLwfy5`,
	"content": `if_H16YTzzXEN_qoGMiC`,
	"section": `hInGx_tfZWpCw6WI4iz4`,
	"sectionTitle": `Lne42pM0sor5IISUNFa4`,
	"timeframeGrid": `CLPpTna2q1n2pZ4lOT0r`,
	"timeframeButton": `BhMt1T4_I8nPDDCViRVf`,
	"active": `qnvGTyLEAi8FjAJSW4xg`,
	"toolsGrid": `I1TNpouK6Ym3IdnUIxku`,
	"toolButton": `B5skaWO8DqE_E79_mQSy`,
	"toolIcon": `PQNvSp9TZvwabXKGyqUc`,
	"toolLabel": `Wr68Ht5swYCfA3BAJQyb`,
	"layoutGridCompact": `E5TwqJLspQmOYSauBWJI`,
	"gridItemCompact": `_U1Pd2xueomDr0RBchPq`,
	"syncOptionsCompact": `a_Bo3aN7JUucAKA8FK9h`,
	"syncOption": `kJKvpd0ye3h1_LUmIzWl`,
	"featuresGrid": `UYoV99reRzXLEqZbyEU7`,
	"featureButton": `Nx7hZy3OKTNu1k8fyEq3`,
	"chartsGridCompact": `EKbvtkhSKqiUvMYLUWyD`,
	"chartItemCompact": `bOb5S75yAbRK5wmW9JO5`,
	"chartIndicator": `buBX960FHS0lusxsvHQJ`,
	"chartSymbol": `YOWWls9x9R015PZbick4`,
	"chartTimeframe": `k8dNMISl3cdxGT3OHE4w`
};
export default ___CSS_LOADER_EXPORT___;
